import { useSyncExternalStore } from 'react';

export type NamiPanelLayout = 'docked' | 'overlay';

/**
 * Below this viewport width the docked panel would squeeze the page too far,
 * so the panel overlays the content instead of shrinking it.
 */
export const DOCK_MIN_VIEWPORT_PX = 1280;

const DOCK_QUERY = `(min-width: ${String(DOCK_MIN_VIEWPORT_PX)}px)`;

function canMatchMedia(): boolean {
  return (
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  );
}

function subscribe(onChange: () => void): () => void {
  if (!canMatchMedia()) return () => {};
  const query = window.matchMedia(DOCK_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  // Without matchMedia (older test environments) fall back to docked: it is
  // the layout the app is designed around.
  if (!canMatchMedia()) return true;
  return window.matchMedia(DOCK_QUERY).matches;
}

function getServerSnapshot(): boolean {
  return true;
}

/**
 * `'docked'` when the viewport is wide enough for the panel to take real
 * estate from the page; `'overlay'` when it should float above the content.
 * Backed by a media query so it is deterministic and mockable.
 */
export function useNamiPanelLayout(): NamiPanelLayout {
  const wide = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return wide ? 'docked' : 'overlay';
}
